<div class="fixed transform z-1" *ngIf="showProgressSpinner">
  <app-custom-spinner></app-custom-spinner>
</div>
<p-toast position="top-right" key="save"></p-toast>
<ng-container *ngIf="!specBool">
  <div class="bg-default px-3 pb-3">
    <div class="flex justify-content-between align-items-center title-bg title-case">
      <div class="conten clean-small">
        <div class="btn"><a>Facility Specifics</a></div>
      </div>
      <!-- <div class="flex justify-content-end standard-spec" id="facility_specs_search">
        <span class="p-input-icon-left"><i class="pi pi-search"></i>
          <input pInputText type="text" [(ngModel)]="searchField" (input)="applyFilterGlobal($event, 'contains')"
            placeholder="Search Facility Specifics" />
            <i class="pi pi-times case-keywordsearch" *ngIf="crossSearchBool" (click)="clearSearchField()"></i>

        </span>
      </div> -->

    </div>
    <div class="grid flex justify-content-end">
      <div class="col-12 md:col-6 lg:col-2 mt-2" *ngIf="!RoleName.toLowerCase().includes('facility')">
        <label><b>System</b></label>
        <span class="p-input-icon-right w-full">
          <p-multiSelect (onChange)="GetFacility()" (click)="GetAllData('system')" [options]="systemList" placeholder="-- Select --" filterBy="Text"
            defaultLabel="--Select--" display="chip" [(ngModel)]="selectedSystem" optionLabel="Text" optionValue="Value"
            virtualScrollItemSize="43" [filter]="true" [virtualScroll]="true">
          </p-multiSelect>
        </span>
      </div>
      <div class="col-12 md:col-6 lg:col-2 mt-2">
        <label><b>Facility</b></label>
        <span class="p-input-icon-right w-full">
          <p-multiSelect (onChange)="OnFacilityChange()" (click)="GetAllData('facility')" [options]="facilityList" placeholder="-- Select --"
            filterBy="Text" defaultLabel="--Select--" display="chip" [(ngModel)]="selectedFacility" optionLabel="Text"
            optionValue="Value" virtualScrollItemSize="43" [filter]="true" [virtualScroll]="true">
          </p-multiSelect>
        </span>
      </div>
    </div>

    <app-common-facility-grid 
    [commonFacilityData]="facilitySpecsGrid" 
    [totalRecords]="totalRecords"
    [isAccessRead]="isAccessRead" 
    [isAccessReadWrite]="isAccessReadWrite"
    (lazyLoadEvent)="lazyLoadSchedulesForSpec($event)" 
    [roleForFacility]="roleForFacility"
    (onContextMenuEvent)="onContextMenu($event)"
    (getFacilityDetailByFacilityIdEvent)="getFacilityDetailByFacilityId($event.facilityId, $event.facilityName)">
    </app-common-facility-grid>

    <div class="md:col-12">
      <span class="tableRefreshTime">
        Grid Last Refreshed at {{PiTeamService._currentDate}} - {{PiTeamService._currentTime}}
      </span>
    </div>
  </div>
</ng-container>
<!-- ///////////////////////////////////Split Screen (Contact)///////////////////////////////////////////////////// -->

<ng-container *ngIf="specBool">

  <div class="bg-default px-3 pb-3">
    <div class="flex flex-column md:flex-row card-container indigo-container justify-content-between align-items-center">
      <div class="flex align-items-center justify-content-center h-2rem m-2">
        <span class="back-button  ml-3 mb-1 cursor-pointer" (click)="routeBack();" pTooltip="Back" tooltipPosition="right">
          <i class="pi pi-arrow-left"></i>
        </span>
        <p-toast position="top-right" key="Contact"></p-toast>
      </div>
      <div class="facility-field flex align-items-center justify-content-center h-2rem m-2">
        <span class="p-input-icon-right w-full">
          <p-dropdown class="w-full" placeholder="Select Facility" [options]="facilityList" [(ngModel)]="facilityID"
            (onChange)="updateFaciiltyDataViaDropdown();" optionValue="Value" [filter]="true"
            optionLabel="Text">
          </p-dropdown>
        </span>
      </div>
      <div class="flex align-items-center justify-content-center h-2rem m-2">
        <button *ngIf="!roleForFacility" pButton pRipple type="button" (click)="AccessFacility()" label="OPEN FACILITY IN TELECARE"
        class="p-button-raised p-button-text p-button-plain"></button>
      </div>
    </div>
    <hr>
    <p-tabView (onChange)="switchHeaders($event);">
      <p-tabPanel header="{{facilityOrContact}}" (click)="faciltyPanelBool = 0">
        <div>
          <form [formGroup]="form" (ngSubmit)="submit()">
            <div [ngStyle]="isAccessRead?{'pointer-events': 'none'} : {'pointer-events': 'all'}" class="grid -mb-7">
              <div class="col-12 md:col-6 lg:col-4">
                <label for="radio2" class="field"><b>Name:</b></label>
                <input type="text" formControlName="fac_name" pInputText />
              </div>
              <div class="col-12 md:col-6 lg:col-4">
                <label for="radio2" class="field"><b>System:</b></label>
                <p-dropdown (click)="GetAllData('system')" [options]="systemList" placeholder="--Select--" formControlName="fac_ucd_key_system"
                  optionLabel="Text" optionValue="Value"></p-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-4">
                <label for="radio2" class="field"><b>Regional:</b></label>
                <p-dropdown (click)="GetAllData('regional')" [options]="regiionalList" placeholder="--Select--" formControlName="fac_ucd_region_key"
                  optionLabel="Text" optionValue="Value"></p-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-4">
                <label for="radio2" class="field"><b>Facility Type:</b></label>
                <p-dropdown [options]="Facility_Type" placeholder="--Select--" formControlName="fac_fct_key"
                  optionLabel="ucd_title" optionValue="ucd_key"></p-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-4">
                <label for="radio2" class="field"><b>Main Facility:</b></label>
                <p-dropdown (click)="GetAllData('facility')" [options]="facilityList" placeholder="--Select--" formControlName="fac_freestanding_fac_key"
                  optionLabel="Text" optionValue="Value"></p-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-4">
                <label for="radio2" class="field"><b>Address Line 1:</b></label>
                <input type="text" formControlName="fac_address_line1" pInputText />
              </div>
              <div class="col-12 md:col-6 lg:col-4">
                <label for="radio2" class="field"><b>Address Line 2:</b></label>
                <input type="text" formControlName="fac_address_line2" pInputText />
              </div>
              <div class="col-12 md:col-6 lg:col-4">
                <label for="radio2" class="field"><b>City:</b></label>
                <input type="text" formControlName="fac_city" pInputText />
              </div>
              <div class="col-12 md:col-6 lg:col-4">
                <label for="radio2" class="field"><b>State:</b></label>
                <p-dropdown (click)="GetAllData('state')" [options]="stateList" placeholder="--Select--" formControlName="fac_stt_key"
                  optionLabel="Text" optionValue="Value"></p-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-4">
                <label for="radio2" class="field"><b>ZIP/Postal Code:</b></label>
                <input type="text" formControlName="fac_zip" pInputText />
              </div>
              <div class="col-12 md:col-6 lg:col-4">
                <label for="radio2" class="field"><b>Time Zone:</b></label>
                <p-dropdown [options]="Time_Zone" optionLabel="tmz_name" formControlName="fac_timezone"
                  optionValue="tmz_key"></p-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-4">
                <label for="radio2" class="field"><b>MD-Staff Source Name:</b></label>
                <input type="text" formControlName="fac_md_staff_source_name" pInputText />
              </div>
              <div class="col-12 md:col-6 lg:col-4">
                <label for="radio2" class="field"><b>MD-Staff Source ID:</b></label>
                <input type="text" 
                  [ngStyle]="true?{'pointer-events': 'none'} : {'pointer-events': 'all'}"
                  formControlName="fac_md_staff_reference_source_id" pInputText />
              </div>
              <div class="col-12 md:col-6 lg:col-4">
                <label for="radio2" class="field"><b>TS Account ID #</b></label>
                <input type="text" formControlName="fac_ts_account_ID" pInputText />
              </div>
              <div class="col-12 md:col-6 lg:col-4">
                <label for="radio2" class="field"><b>Facility Short Name:</b></label>
                <input type="text" formControlName="fac_short_name" pInputText />
              </div>
              <div class="col-12 md:col-6 lg:col-4">
                <label for="radio2" class="field"><b>Client Site ID:</b></label>
                <input type="text" formControlName="fac_facility_id" pInputText />
              </div>
              <div class="col-12 md:col-6 lg:col-4">
                <label for="radio2" class="field"><b>Pulsara Hook Id:</b></label>
                <input type="text" formControlName="fac_pulsara_id" pInputText />
              </div>
              <div class="col-12 md:col-6 lg:col-4">
                <label for="radio2" class="field"><b>Facility Go Live Date TeleNeuro:</b></label>
                <p-calendar [showIcon]="true" inputId="icon" formControlName="fac_go_live_date" [readonlyInput]="true"></p-calendar>
              </div>
              <div class="col-12 md:col-6 lg:col-4">
                <div>
                  <p-checkbox [binary]="true" formControlName="fac_go_live" inputId="fac_go_live"></p-checkbox>
                  <label class="ml-2" for="binary">GoLive-TeleNeuro</label>
                </div>
                <div *ngIf="telePsychBool" class="mt-2">
                  <p-checkbox [binary]="true" formControlName="fac_go_live_telepsych" inputId="fac_go_live_telepsych"></p-checkbox>
                  <label class="ml-2" for="binary">GoLive-TelePsych</label>
                </div>
                <div class="mt-2">
                  <p-checkbox [binary]="true" formControlName="fac_added_from_go_live" inputId="fac_added_from_go_live"></p-checkbox>
                  <label class="ml-2" for="binary">GO Live In Upcoming Days</label>
                </div>
                <div class="mt-2">
                  <p-checkbox [binary]="true" formControlName="fac_is_active" inputId="fac_is_active"></p-checkbox>
                  <label class="ml-2" for="binary">Implementation</label>
                </div>
                <div class="mt-2">
                  <p-checkbox [binary]="true" formControlName="fac_dispatch_priority" inputId="fac_dispatch_priority"></p-checkbox>
                  <label class="ml-2" for="binary">Prioritize for Dispatch</label>
                </div>
              </div>
              <div *ngIf="telePsychBool" class="field  col-4 md:col-4 mt-1">
                <label for="radio2" class="field"><b>Facility Go Live Date TelePsych:</b></label>
                <p-calendar [showIcon]="true" inputId="icon" formControlName="fac_go_live_date_telepsych" [readonlyInput]="true"></p-calendar>
              </div>
            </div>
            <div class="grid facility-infosecond">
              <div class="col-12 md:col-12 lg:col-4">
                <div [ngStyle]="isAccessRead?{'pointer-events': 'none'} : {'pointer-events': 'all'}" class="field  col mt-3">
                  <label for="radio2" class="field"><b>Teleneurology QPS:</b></label>
                  <p-dropdown [options]="Teleneuro_QPS" formControlName="qps_number" optionLabel="Text"
                    optionValue="Value"></p-dropdown>
                </div>
                <div [ngStyle]="isAccessRead?{'pointer-events': 'none'} : {'pointer-events': 'all'}" class="field  col mt-3">
                  <label for="radio2" class="field"><b>TS Regional Medical Director:</b></label>
                  <p-dropdown [options]="Medical_Director" formControlName="fac_medicaldirector_assigned"
                    optionLabel="Text" optionValue="Value"></p-dropdown>
                </div>
                <div class="field cta-protocol col mt-3">
                  <label for="LastName"><b>CTA Protocol:</b></label>
                  <span class="p-input-icon-right">
                    <textarea [rows]="3" [cols]="30" formControlName="fac_hospital_CTA_protocol" [readonly]="isAccessRead"
                      pInputTextarea></textarea>
                  </span>
                </div>
              </div>

              <div class="col-12 md:col-12 lg:col-8">
                <p-panel header="Best Practices" [toggleable]="true" [collapsed]="false">
                  <div [ngStyle]="isAccessRead?{'pointer-events': 'none'} : {'pointer-events': 'all'}"
                    class="formgrid grid">
                    <div class="col-4 md:col-4 field-checkbox">
                      <p-checkbox [binary]="true" formControlName="fac_pre_activation" inputId="fac_pre_activation"></p-checkbox>
                      <label for="binary">Pre-activation</label>
                    </div>
                    <div class="col-4 md:col-4 field-checkbox">
                      <p-checkbox [binary]="true" formControlName="fac_stroke_Kits" inputId="fac_stroke_Kits"></p-checkbox>
                      <label for="binary">Stroke Kits (Meds and Supplies)</label>
                    </div>
                    <div class="col-4 md:col-4 field-checkbox">
                      <p-checkbox [binary]="true" formControlName="fac_pit_stop_process" inputId="fac_pit_stop_process"></p-checkbox>
                      <label for="binary">Pit stop process or launch pad</label>
                    </div>
                    <div class="col-4 md:col-4 field-checkbox">
                      <p-checkbox [binary]="true" formControlName="fac_early_alteplase_mix" inputId="fac_early_alteplase_mix">
                      </p-checkbox>
                      <label for="binary">Early Alteplase mix (on verbal order)</label>
                    </div>
                    <div class="col-4 md:col-4 field-checkbox">
                      <p-checkbox [binary]="true" formControlName="fac_stroke_assessment_tool" inputId="fac_stroke_assessment_tool">
                      </p-checkbox>
                      <label for="binary">Stroke assessment tool used (SAVES or BEFAST)</label>
                    </div>
                    <div class="col-4 md:col-4 field-checkbox">
                      <p-checkbox [binary]="true" formControlName="fac_cart_to_CT" inputId="fac_cart_to_CT"></p-checkbox>
                      <label for="binary">Cart to CT with patient</label>
                    </div>
                    <div class="col-4 md:col-4 field-checkbox">
                      <p-checkbox [binary]="true" formControlName="fac_bedside_mixing_of_alteplase" inputId="fac_bedside_mixing_of_alteplase">
                      </p-checkbox>
                      <label for="binary">Bedside mixing of alteplase (RN or Pharmacist)</label>
                    </div>
                    <div class="col-4 md:col-4 field-checkbox">
                      <p-checkbox [binary]="true" formControlName="fac_alteplase_administration_in_CT" inputId="fac_alteplase_administration_in_CT">
                      </p-checkbox>
                      <label for="binary">Alteplase administration in CT</label>
                    </div>
                    <div class="col-4 md:col-4 field-checkbox">
                      <p-checkbox [binary]="true" formControlName="fac_designated_stroke_team" inputId="fac_designated_stroke_team">
                      </p-checkbox>
                      <label for="binary">Designated stroke team with PI and data sharing</label>
                    </div>

                  </div>
                </p-panel>
              </div>
            </div>
            <div class="formgrid flex m-2">
              <div class="col-12 md:col-12 text-right mt-5">
                <button pButton type="button" (click)="backToSpec('Cancel')" class=" btn-UnCancelCase">
                  <i class="pi pi-times"></i>&nbsp; <b>Cancel</b> </button>
                <p-button *ngIf="isAccessReadWrite" [disabled]="onClickDisable"
                  [ngStyle]="onClickDisable?{'pointer-events': 'none'} : {'pointer-events': 'all'}" type="button"
                  class="p-button-primary btn-padding-custom" (click)="submit()" label="Save" icon="pi pi-save">
                </p-button>
              </div>
            </div>
          </form>
        </div>
      </p-tabPanel>

      <!-- ///////////////////////////////////Contact Information Start///////////////////////////////////////////////////// -->
      <p-tabPanel class="facility-table" header="Contact" (click)="faciltyPanelBool = 1">
        <div class="bg-default px-3 pb-3">
          <div class="flex justify-content-end">
            <p-button *ngIf="isAccessReadWrite" label="Add Contact" icon="pi pi-plus" class="p-button-primary"
              (click)="addContact()"></p-button>
          </div>
          <p-table #dt [value]=" facilityContact" [rows]="rows" styleClass="p-datatable-striped p-datatable-gridlines"
            [paginator]="true" sortMode="multiple" [lazy]="true" (onLazyLoad)="lazyLoadSchedulesForContact($event)"
            responsiveLayout="scroll" [rowHover]="true" dataKey="Id" [totalRecords]="totalRecords" [columns]="cols"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [resizableColumns]="false"
            [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50,totalRecords]"
            [globalFilterFields]="['cnt_first_name','cnt_last_name','cnt_role_name','cnt_role','cnt_primary_phone','cnt_extension','cnt_mobile_phone','cnt_email']">
            <ng-template pTemplate="header">
              <tr [ngStyle]="isAccessRead?{'pointer-events': 'none'} : {'pointer-events': 'all'}">
                <th pSortableColumn="cnt_first_name" pResizableColumn>First Name
                  <p-sortIcon field="cnt_first_name"></p-sortIcon>
                </th>
                <th pSortableColumn="cnt_last_name" pResizableColumn>Last Name
                  <p-sortIcon field="cnt_last_name"></p-sortIcon>
                </th>
                <th pSortableColumn="cnt_role_name" pResizableColumn>Contact Role
                  <p-sortIcon field="cnt_role_name"></p-sortIcon>
                </th>
                <th pSortableColumn="cnt_role" pResizableColumn>Department / Role
                  <p-sortIcon field="cnt_role"></p-sortIcon>
                </th>
                <th pSortableColumn="cnt_primary_phone" pResizableColumn>Primary Phone
                  <p-sortIcon field="cnt_primary_phone"></p-sortIcon>
                </th>
                <th pSortableColumn="cnt_extension" pResizableColumn>Extension
                  <p-sortIcon field="cnt_extension"></p-sortIcon>
                </th>
                <th pSortableColumn="cnt_mobile_phone" pResizableColumn>Mobile Phone
                  <p-sortIcon field="cnt_mobile_phone"></p-sortIcon>
                </th>
                <th pSortableColumn="cnt_email" pResizableColumn>Email
                  <p-sortIcon field="cnt_email"></p-sortIcon>
                </th>
                <th pSortableColumn="FacilityName">Active </th>
                <th *ngIf="isAccessReadWrite" pSortableColumn="price" sortMode="multiple">Action </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-facilityContact>
              <tr>
                <input type="hidden" value="facilityContact.cnt_key" />
                <td>{{facilityContact.cnt_first_name}}</td>
                <td>{{facilityContact.cnt_last_name}}</td>
                <td>{{facilityContact.cnt_role_name}}</td>
                <td>{{facilityContact.cnt_role}}</td>
                <td>{{facilityContact.cnt_primary_phone}}</td>
                <td>{{facilityContact.cnt_extension}}</td>
                <td>{{facilityContact.cnt_mobile_phone}}</td>
                <td>{{facilityContact.cnt_email}}</td>
                <td>
                  <p-checkbox [(ngModel)]="facilityContact.cnt_is_active" [binary]="true" [disabled]="true">
                  </p-checkbox>
                </td>
                <td *ngIf="isAccessReadWrite">
                  <button pButton pRipple icon="pi pi-pencil" pTooltip="Edit" tooltipPosition="left"
                    class="p-button-rounded p-button-primary mr-2" (click)="editContact(facilityContact)"></button>
                  <button pButton pRipple icon="pi pi-trash" pTooltip="Delete" tooltipPosition="right"
                    class="p-button-rounded p-button-danger" (click)="deleteFacilityContact(facilityContact)"></button>

                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <h5 *ngIf="totalRecords==0" class="text-center create-roles">
                  <b> No records found</b>
                </h5>
              </tr>
            </ng-template>
          </p-table>

          <!-- /////////////////////////Diaglog for Add Edit Contact/////////////////////////////////// -->

          <p-dialog [(visible)]="addEditContactDialog" [breakpoints]="{'900px': '75vw'}" [draggable]="false"
            [style]="{width: '60vw'}" header="Add Contact" [modal]="true" styleClass="p-fluid">
            <div class="fixed transform z-2" *ngIf="showProgressSpinner">
              <app-custom-spinner></app-custom-spinner>
            </div>
            <ng-template pTemplate="content">
              <div class="grid p-fluid formgrid">
                <form [formGroup]="formContact" (ngSubmit)="submitContact()">
                  <div class="formgrid grid">

                    <div class="field  col-6 md:col-6 mt-3">
                      <label for="radio2" class="field">First Name:</label>
                      <input type="text" formControlName="cnt_first_name" pInputText />
                    </div>

                    <div class="field  col-6 md:col-6 mt-3">
                      <label for="radio2" class="field ">Last Name:</label>
                      <input type="text" formControlName="cnt_last_name" pInputText />
                    </div>

                    <div class="field  col-6 md:col-6">
                      <label for="radio2" class="field">Contact Role:</label>
                      <p-dropdown [options]="contactRoleOptions" formControlName="cnt_role_ucd_key" optionLabel="name"
                        optionValue="code"></p-dropdown>
                    </div>

                    <div class="field  col-6 md:col-6">
                      <label for="radio2" class="field">Department/Role:</label>
                      <input type="text" formControlName="cnt_role" pInputText />
                    </div>

                    <div class="field col-6 md:col-6">
                      <ng-container *ngIf="!cntPrimaryPhone">
                        <label for="radio2" class="field">Primary Phone:<span
                            [ngClass]="fc['cnt_primary_phone'].errors || fc['cnt_primary_phone'].errors ? 'invalid-feedback' : 'valid-feedback'">
                            *</span></label>
                      </ng-container>
                      <ng-container *ngIf="cntPrimaryPhone">
                        <label for="radio2" class="field">Primary Phone:<span
                            [ngClass]="fc['cnt_primary_phone'].errors || fc['cnt_primary_phone'].errors ? 'valid-feedback' : 'valid-feedback'">
                            *</span></label>
                      </ng-container>

                      <p-inputMask (focusout)="checkPhoneValidation('cnt_primary_phone')" class="w-full"
                        id="cnt_primary_phone" name="primaryPhone" formControlName="cnt_primary_phone"
                        mask="(999) 999-9999" class="inputfield w-full">
                      </p-inputMask>
                      <ng-container *ngIf="!cntPrimaryPhone">
                        <div
                          *ngIf="fc['cnt_primary_phone'].errors && (fc['cnt_primary_phone'].touched || fc['cnt_primary_phone'].dirty)"
                          class="invalid-feedback">
                          <div *ngIf="fc['cnt_primary_phone'].errors['required']">Primary Phone or Mobile Phone is
                            required</div>
                        </div>
                      </ng-container>

                    </div>
                    <div class="field col-6 md:col-6">
                      <label for="radio2" class="field">Extension:</label>
                      <input type="text" formControlName="cnt_extension" pInputText />
                    </div>
                    <div class="field col-6 md:col-6">
                      <ng-container *ngIf="!cntMobilePhoneBool">
                        <label for="radio2" class="field">Mobile Phone:<span
                            [ngClass]="fc['cnt_mobile_phone'].errors || fc['cnt_mobile_phone'].errors ? 'invalid-feedback' : 'valid-feedback'">
                            *</span></label>
                      </ng-container>
                      <ng-container *ngIf="cntMobilePhoneBool">
                        <label for="radio2" class="field">Mobile Phone:<span
                            [ngClass]="fc['cnt_mobile_phone'].errors || fc['cnt_mobile_phone'].errors ? 'valid-feedback' : 'valid-feedback'">
                            *</span></label>
                      </ng-container>
                      <p-inputMask (focusout)="checkPhoneValidation('cnt_mobile_phone')" class="w-full"
                        name="mobilePhone" formControlName="cnt_mobile_phone" mask="(999) 999-9999"
                        class="inputfield w-full"></p-inputMask>
                      <ng-container *ngIf="!cntMobilePhoneBool">
                        <div
                          *ngIf="fc['cnt_mobile_phone'].errors && (fc['cnt_mobile_phone'].touched || fc['cnt_mobile_phone'].dirty)"
                          class="invalid-feedback">
                          <div *ngIf="fc['cnt_mobile_phone'].errors['required']">Primary Phone or Mobile Phone is
                            required</div>
                        </div>
                      </ng-container>
                    </div>
                    <div class="field  col-6 md:col-6">
                      <label for="radio2" class="field">Email:<span
                          [ngClass]="fc['cnt_email'].errors || fc['cnt_email'].errors ? 'invalid-feedback' : 'valid-feedback'">
                          *</span></label>
                      <input type="text" formControlName="cnt_email" pInputText />
                      <div *ngIf="fc['cnt_email'].errors && (fc['cnt_email'].touched || fc['cnt_email'].dirty)"
                        class="invalid-feedback">
                        <div *ngIf="fc['cnt_email'].errors['required']">Email is required</div>
                        <div *ngIf="fc['cnt_email'].errors['email']">Invalid Email Format</div>
                      </div>
                    </div>
                    <div class="field  col-12 md:col-12">
                      <p-checkbox formControlName="cnt_is_active" [binary]="true"></p-checkbox>
                      <label class="-mb-3 ml-3" for="active">Active</label>
                    </div>
                    <div class="field col-12 justify-content-end flex input-group-append mb-2 mt-3">
                      <button pButton type="button" (click)="backToSpec('hideContactDiaglog')" class="btn-UnCancelCase">
                        <i class="pi pi-times"></i>&nbsp; <b>Cancel</b> </button>
                      <ng-container *ngIf="buttonText == 'saveContact'">
                        <p-button
                          [ngStyle]="formContact.invalid && disabledButton?{'pointer-events': 'none'} : {'pointer-events': 'all'}"
                          icon="pi pi-save" type="button" [disabled]="formContact.invalid" (click)="submitContact()"
                          class="p-button-primary btn-padding-custom" label="Save"></p-button>
                      </ng-container>
                      <p-button [ngStyle]="onClickDisable?{'pointer-events': 'none'} : {'pointer-events': 'all'}"
                        *ngIf="buttonText == 'editContact'" class="p-button-primary btn-padding-custom" type="button"
                        (click)="editFacilityContact()" icon="pi pi-save" label="Update"></p-button>
                    </div>
                  </div>
                </form>
              </div>
            </ng-template>
          </p-dialog>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
</ng-container>
<div class="toast-container" [ngClass]="{'toast-mask': showToast}"></div>
<p-toast [style]="{width: '25vw',opacity:'1'}" position="center" key="c" (onClose)="onReject()">
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column" style="flex: 1">
      <div class="text-center">
        <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
        <h4>{{message.summary}}</h4>
        <p>{{message.detail}}</p>
      </div>
      <div class="grid p-fluid">
        <div class="col-6">
          <p-button label="YES" class="ml-2 p-button-primary btn-padding-custom" (click)="onConfirm()" type="button">
          </p-button>
        </div>
        <div class="col-6">
          <p-button label="No" class="ml-2 p-button-secondary btn-padding-custom" (click)="onReject()" type="button">
          </p-button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
